import {
  duplicateItem as publicDuplicateItem,
  createItem as publicCreateItem,
  bulkCreateItems as publicBulkCreateItems,
  getItem as publicGetItem,
  listItems as publicListItems,
  queryItems as publicQueryItems,
  typedQueryItems as publicTypedQueryItems,
  searchItems as publicSearchItems,
  countItems as publicCountItems,
  updateItem as publicUpdateItem,
  bulkUpdateItem as publicBulkUpdateItem,
  deleteItem as publicDeleteItem,
  bulkDeleteItems as publicBulkDeleteItems,
} from './restaurants-menus-v1-item-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ItemQuery,
  ItemsQueryBuilder,
  typedQueryItems as universalTypedQueryItems,
} from './restaurants-menus-v1-item-items.universal.js';
import { onItemCreated as publicOnItemCreated } from './restaurants-menus-v1-item-items.public.js';
import { onItemDeleted as publicOnItemDeleted } from './restaurants-menus-v1-item-items.public.js';
import { onItemUpdated as publicOnItemUpdated } from './restaurants-menus-v1-item-items.public.js';

function customQueryItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryItems(httpClient)(),
    typedQueryFunction: (query: ItemQuery) =>
      publicTypedQueryItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ItemsQueryBuilder;
  function overloadedQuery(
    query: ItemQuery
  ): ReturnType<typeof universalTypedQueryItems>;
  function overloadedQuery(query?: ItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const duplicateItem: MaybeContext<
  BuildRESTFunction<typeof publicDuplicateItem> & typeof publicDuplicateItem
> = /*#__PURE__*/ createRESTModule(publicDuplicateItem);
export const createItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateItem> & typeof publicCreateItem
> = /*#__PURE__*/ createRESTModule(publicCreateItem);
export const bulkCreateItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateItems> & typeof publicBulkCreateItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateItems);
export const getItem: MaybeContext<
  BuildRESTFunction<typeof publicGetItem> & typeof publicGetItem
> = /*#__PURE__*/ createRESTModule(publicGetItem);
export const listItems: MaybeContext<
  BuildRESTFunction<typeof publicListItems> & typeof publicListItems
> = /*#__PURE__*/ createRESTModule(publicListItems);
export const searchItems: MaybeContext<
  BuildRESTFunction<typeof publicSearchItems> & typeof publicSearchItems
> = /*#__PURE__*/ createRESTModule(publicSearchItems);
export const countItems: MaybeContext<
  BuildRESTFunction<typeof publicCountItems> & typeof publicCountItems
> = /*#__PURE__*/ createRESTModule(publicCountItems);
export const updateItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateItem> & typeof publicUpdateItem
> = /*#__PURE__*/ createRESTModule(publicUpdateItem);
export const bulkUpdateItem: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateItem> & typeof publicBulkUpdateItem
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateItem);
export const deleteItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteItem> & typeof publicDeleteItem
> = /*#__PURE__*/ createRESTModule(publicDeleteItem);
export const bulkDeleteItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteItems> & typeof publicBulkDeleteItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteItems);
export const queryItems: MaybeContext<
  BuildRESTFunction<typeof customQueryItems> & typeof customQueryItems
> = /*#__PURE__*/ createRESTModule(customQueryItems);
/** */
export const onItemCreated: BuildEventDefinition<typeof publicOnItemCreated> &
  typeof publicOnItemCreated = createEventModule(publicOnItemCreated);
/** */
export const onItemDeleted: BuildEventDefinition<typeof publicOnItemDeleted> &
  typeof publicOnItemDeleted = createEventModule(publicOnItemDeleted);
/**
 * Triggered when an item is updated.
 */
export const onItemUpdated: BuildEventDefinition<typeof publicOnItemUpdated> &
  typeof publicOnItemUpdated = createEventModule(publicOnItemUpdated);

export {
  FulfillmentMethodType,
  AvailabilityType,
  EntitiesDayOfWeek,
  Enum,
  State,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
  WebhookIdentityType,
  SortOrder,
  SortType,
  SortDirection,
  ScalarType,
  AggregationType,
  Mode,
} from './restaurants-menus-v1-item-items.universal.js';
export {
  Item,
  ItemPricingOneOf,
  PriceVariants,
  PriceVariant,
  PriceInfo,
  Label,
  OrderSettings,
  Availability,
  AvailabilityAvailabilityTypeOptionsOneOf,
  WeeklyScheduleOptions,
  DayOfWeekAvailability,
  TimeOfDayRange,
  TimeOfDay,
  TimestampRangesOptions,
  AvailableRange,
  ModifierGroup,
  ExtendedFields,
  ExternalReferenceInfo,
  DuplicateItemRequest,
  DuplicateItemResponse,
  UpdateDocumentsEvent,
  UpdateDocumentsEventOperationOneOf,
  DocumentUpdateOperation,
  IndexDocument,
  DocumentPayload,
  DocumentImage,
  DeleteByIdsOperation,
  DeleteByFilterOperation,
  UpdateByFilterOperation,
  UpdateExistingOperation,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SearchIndexingNotification,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  DeleteLocationIdsFromVariants,
  DeleteLocationIdsFromModifierGroups,
  CreateItemRequest,
  CreateItemResponse,
  BulkCreateItemsRequest,
  BulkCreateItemsResponse,
  BulkCreateItemResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetItemRequest,
  GetItemResponse,
  ListItemsRequest,
  CursorPaging,
  ListItemsResponse,
  CursorPagingMetadata,
  Cursors,
  QueryItemsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryItemsResponse,
  SearchItemsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  ValueAggregation,
  RangeAggregation,
  ScalarAggregation,
  SearchDetails,
  SearchItemsResponse,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  ValueResults,
  RangeResults,
  ScalarResult,
  AggregationResults,
  AggregationResultsResultOneOf,
  CountItemsRequest,
  CountItemsResponse,
  UpdateItemRequest,
  UpdateItemResponse,
  BulkUpdateItemRequest,
  MaskedItem,
  BulkUpdateItemResponse,
  BulkUpdateItemResponseBulkItemResult,
  DeleteItemRequest,
  DeleteItemResponse,
  BulkDeleteItemsRequest,
  BulkDeleteItemsResponse,
  BulkDeleteItemResult,
  CloneItemsRequest,
  CloneItemsResponse,
  BulkUpdateBusinessLocationIdsRequest,
  BulkUpdateBusinessLocationIdsResponse,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult,
  BulkUpdateBusinessLocationIdsPerEntityRequest,
  ItemIdLocationIds,
  BulkUpdateBusinessLocationIdsPerEntityResponse,
  BulkItemResult,
  SyncContentToMultilingualRequest,
  SyncContentToMultilingualResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ItemCreatedEnvelope,
  ItemDeletedEnvelope,
  ItemUpdatedEnvelope,
  DuplicateItemOptions,
  BulkCreateItemsOptions,
  ListItemsOptions,
  ItemsQueryResult,
  ItemsQueryBuilder,
  ItemQuerySpec,
  ItemSearchSpec,
  CountItemsOptions,
  UpdateItem,
  BulkUpdateItemOptions,
} from './restaurants-menus-v1-item-items.universal.js';
export { utils } from './restaurants-menus-v1-item-items.universal.js';
export {
  FulfillmentMethodTypeWithLiterals,
  AvailabilityTypeWithLiterals,
  EntitiesDayOfWeekWithLiterals,
  EnumWithLiterals,
  StateWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  ScalarTypeWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  CountItemsApplicationErrors,
  CommonQueryWithEntityContext,
  ItemQuery,
  CommonSearchWithEntityContext,
  ItemSearch,
} from './restaurants-menus-v1-item-items.universal.js';
